<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ 'PRODUCTS.TITLE.PRINT_' + labelType.toUpperCase() | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <table width="100%">
    <tr style="height: 30px;">
      <th width="70%">{{'PRODUCTS.FIELDS.SKU' | translate}}</th>
      <th>{{'PRODUCTS.FIELDS.QUANTITY' | translate}}</th>
    </tr>
    <tr *ngFor="let label of labels">
      <td>
        {{label.sku}}
        <img marketplaceIconFallback *ngIf="label.storeType" src="assets/media/icons/{{label.storeType?.toLowerCase()}}-icon.png">
        {{label.storeName}}
      </td>
      <td><input class="form-control" [(ngModel)]="label.quantity"></td>
    </tr>
  </table>
  <form [formGroup]="formGroup" class="kt-margin-t-20">
    <div class="form-group" *ngIf="receivingFnsku == true">
      <label class="strong">Please Select Store</label>
      <ng-select [items]="stores.getAll()" bindLabel="name" bindValue="id" 
        [clearable]="true" (change)="getFnskus($event)"></ng-select>
    </div>
    <div class="form-group">
      <label class="strong">Label size</label>
      <ng-select [items]="allSizes" bindLabel="text" bindValue="value" formControlName="count"
        [clearable]="false"></ng-select>
    </div>
    <div *ngIf="formGroup.value.count == 1">
      <h4>Print options</h4>
      <p>Minimum dimensions for this type of labels are 25 mm × 25 mm.</p>
      <div class="form-group">
        <label>Width</label>
        <div class="input-group">
          <input class="form-control" formControlName="width">
          <div class="input-group-append"><span class="input-group-text">mm</span></div>
        </div>
      </div>
      <div class="form-group">
        <label>Height</label>
        <div class="input-group">
          <input class="form-control" formControlName="height">
          <div class="input-group-append"><span class="input-group-text">mm</span></div>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
    (click)="activeModal.dismiss()">{{ 'GENERAL.BUTTONS.CANCEL' | translate }}</button>
  <button type="button" class="btn btn-brand" (click)="print()">{{ 'GENERAL.BUTTONS.PRINT' | translate }}</button>
</div>
<svg id="label" style="display: none;"></svg>